<template>
  <div class="block_wrap">
    <div class="response_table role_table">
      <table>
        <thead style="flex:0;">
          <tr>
            <th scope="col"> Role </th>
            <th scope="col"> Permissions </th>
            <th scope="col" v-if="edit_rbac" > Action </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(role, role_key) in all_roles_list" :key="role_key" class="role">
            <td data-label="Name">
              <span>{{ role.name }}</span>
            </td>

            <td data-label="Permissions" class="permissions">
              <span
                  v-for="(permission, permission_key) in role.permissions"
                  :key="permission_key"
                  :title="permission_list[permission].description"
              >
                {{ permission_key !== role.permissions.length -1 ? permission + ',' : permission }}
              </span>
            </td>

            <td data-label="action" v-if="edit_rbac">
              <span
                  v-if="role.checked"
                  class="action revoke btn btn-danger btn-wd"
                  @click="revoke_role(role)"
              >
                {{ translate('notification.btn.delete') }}
              </span>

              <span
                  v-else
                  class="action assign btn btn-success btn-wd"
                  @click="assign_role(role)"
              >
                {{ translate('notification.btn.add') }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: "EditRolesForm",
  props: ['user_id'],
  data () {
    return {
      pwd: true,
      disabled_btn: false,
      old_url: '',
      user_roles: [],
      role_list: [],
      permission_list: []
    }
  },
  created(){
    this.get_all_roles_and_permissions()
    this.get_user_roles()
  },
  computed:{
    all_roles_list(){
      let all_roles_list = this.role_list
      for (let key in all_roles_list) {
        all_roles_list[key].checked = this.user_roles.includes(all_roles_list[key].name)
      }
      return all_roles_list
    },
    edit_rbac(){
      return this.$store.getters.getPermissions.editRbac === true
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    get_all_roles_and_permissions(){
      this.$http.v1.getAllRoles((response) => {
        this.role_list = response.data.roles
        this.permission_list = response.data.permissions

      })
    },
    get_user_roles(){
      this.$http.v1.getUserRoles(this.user_id, (response) => {
        this.user_roles = Object.keys(response.data)
      })
    },
    assign_role(role){
      this.$http.v1.assignRoles({user_id: this.user_id, role: role.name}, () => {
        this.global_notify('info', this.translate('user.roles.role_assign'))
        this.get_user_roles()
      })
    },
    revoke_role(role){
      this.$http.v1.revokeRoles( {user_id: this.user_id, role: role.name}, () => {
        this.global_notify('info', this.translate('user.roles.role_revoke'))
        this.get_user_roles()
      })
    }
  }
}

</script>
<style lang='scss' scoped>
  .block_wrap{
    height: 100%;
  }
  .role_table{
    table{
      tbody{
        .role{
          .permissions{
            max-height: 150px;
            display: block;
            overflow-y: scroll;
          }
          .action{
            font-size: 14px;
            line-height: 100%;
            cursor: pointer;
            padding: 2px;
          }
        }
      }
    }
  }



</style>
